export default function React_ES6_Template_Strings() {
  return (
    <div>
      <h1>React_ES6_Template_Strings Component</h1>
      <p>This is the React_ES6_Template_Strings tutorial page.</p>
    </div>
  );
}
